import React from 'react';
import { Text, View, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

import { OPPureComponent, Avatar, ProfileAvatar, DateUtils, I18n } from '../components';

import { currentDeploymentInfoForPatient } from './helpers';

export default class DisplayAirman extends OPPureComponent {
  render() {
    const props = this.props;
    const c = this.props.case;
    const patient = this.props.patient;
    if (!c) return null;

    const rank = patient?.rank;
    const group = c?.group;

    const deployment = currentDeploymentInfoForPatient(patient);
    const deploymentLocation = deployment.location;
    const deploymentDate = deployment.date;

    return (
      <View style={[styles.selectedCaseContainer, props.containerStyle]} key={c.caseId}>
        {!!props.patientProfile?.avatarUrl ? (
          <ProfileAvatar profile={props.patientProfile} circleStyles={styles.caseAvatarStyle} />
        ) : (
          <Avatar
            initialsStr={c.name}
            onPress={null}
            attachment={c.avatar}
            circleStyles={styles.caseAvatarStyle}
          />
        )}

        <View style={styles.caseTextContainer}>
          <Text style={styles.caseNameText}>{c.name}</Text>
          <Text style={styles.caseDetailText}>{rank}</Text>
          <Text style={styles.caseDetailText}>{group}</Text>
          {!props.hideDeployment && !!deploymentLocation && (
            <Text style={styles.caseDetailTextThick}>
              {I18n.ce('airforce.deployingTo')}: {deploymentLocation}
            </Text>
          )}
          {!props.hideDeployment && !!deploymentDate && (
            <Text style={styles.caseDetailTextSmall}>
              On: {DateUtils.formatDateString(new Date(deploymentDate))}
            </Text>
          )}
        </View>
        {props.children}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  selectedCaseContainer: {
    ...THEME.basicRow,
    backgroundColor: COLOR.altContrast,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderBottomColor: COLOR.accent,
    borderBottomWidth: 1,
  },
  caseTextContainer: {
    flex: 1,
    marginLeft: 15,
  },
  caseNameText: {
    ...FONT.bold,
    color: COLOR.text,
    fontSize: 14,
  },
  caseDetailText: {
    ...FONT.regular,
    color: COLOR.text,
    fontSize: 14,
    paddingTop: 5,
  },
  caseDetailTextThick: {
    ...FONT.medium,
    color: COLOR.text,
    fontSize: 14,
    paddingTop: 8,
  },
  caseDetailTextSmall: {
    ...FONT.medium,
    color: COLOR.text,
    fontSize: 12,
    paddingTop: 3,
  },
  caseAvatarStyle: {
    width: 50,
    height: 50,
  },
});
